import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classnames from 'classnames';
import Global from '../../store/global-selectors';
import { toggleLabelQue } from '../../store/label-que/label-que.actions';
import LabelQueContent from './components/label-que-content';
import style from './style.module.less';

const LabelQue = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(Global.selectLabelQueIsOpen) ?? true;
  const batchCount = (useSelector(Global.selectLabelQueBatches) || []).length;

  const onToggleQueue = useCallback(() => {
    dispatch(toggleLabelQue(!isOpen));
  }, [dispatch, isOpen]);

  return (
    <div
      className={classnames(style['label-que-wrapper'], {
        [style.closed]: !isOpen,
      })}
    >
      <LabelQueContent batchCount={batchCount} onToggleQue={onToggleQueue} />
    </div>
  );
};

export default LabelQue;
